import { motion } from "framer-motion";
import mark from "@/assets/logo-mark.png";

export default function HorseHeadLogo({ className = "h-11 w-11" }) {
    return (
        <motion.div
            data-testid="horse-head-logo"
            className={`relative ${className}`}
            initial={{ opacity: 0, scale: 0.6, rotate: -14 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
        >
            <motion.img
                src={mark}
                alt="Mane Miles horse head mark"
                className="h-full w-full object-contain"
                animate={{
                    filter: [
                        "drop-shadow(0 0 8px rgba(200, 90, 23, 0.35))",
                        "drop-shadow(0 0 24px rgba(212, 175, 55, 0.6))",
                        "drop-shadow(0 0 8px rgba(200, 90, 23, 0.35))",
                    ],
                }}
                transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut" }}
            />
            <motion.span
                aria-hidden="true"
                className="absolute inset-y-0 left-0 w-1/2 -skew-x-12 bg-gradient-to-r from-transparent via-white/50 to-transparent mix-blend-overlay"
                animate={{ x: ["-40%", "260%"] }}
                transition={{ duration: 2.6, repeat: Infinity, repeatDelay: 3.4, ease: "easeInOut" }}
            />
        </motion.div>
    );
}
